module.exports = __webpack_public_path__ + "static/img/180153_6.be5e70d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_6.jpg
// module id = vSBt
// module chunks = 1